import React from "react";

function DocumentFill() {
  return (
    <span className="anticon anticon-docfill">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 19 23"
      >
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M11.438.667H2.741A2.164 2.164 0 00.578 2.841L.567 20.237c0 1.201.962 2.174 2.163 2.174h13.057a2.174 2.174 0 002.174-2.174V7.19L11.438.667zm-1.087 7.61v-5.98l5.98 5.98h-5.98z"
        ></path>
      </svg>
    </span>
  );
}

export default DocumentFill;
